import {Controller} from "stimulus";

export default class PrefillInputController extends Controller {
  static targets = ["input"];
  static values = {
    value: String,
  };

  declare valueValue: string;
  declare inputTarget: HTMLInputElement;

  prefill() {
    this.inputTarget.value = this.valueValue;
  }
}
